/**
 * Helper to translate option values (like 'etudiant') to their labels in any language
 * The actual option values sent to backend are always the code (like 'etudiant')
 * Only the UI label changes based on language
 */

export type OptionCategory = 
  | 'sex'
  | 'nativeLanguage'
  | 'englishLevel'
  | 'englishExposure'
  | 'dailyWriting'
  | 'educationLevel'
  | 'employmentStatus'
  | 'workSector'
  | 'studySpecialty';

/**
 * Hook to translate backend options to current language
 * @param options - Backend options array with value and label
 * @param category - The option category for translation lookup
 * @param t - i18next translation function
 * @returns Array of options with translated labels
 */
export const useTranslatedOptions = (
  options: Array<{ value: string; label: string }> | undefined,
  category: OptionCategory,
  t: any
): Array<{ value: string; label: string }> => {
  if (!options) return [];
  
  return options.map(option => ({
    value: option.value,
    // Try to find translation, fall back to original label
    label: t(`options.${category}.${option.value}`, { defaultValue: option.label }),
  }));
};
